const menuSelector = ".tabs--menu";
const activeSelector = ".w--current, [aria-current='page'], .is-active";
const mobileMediaQuery = "(max-width: 767px)";

export function initTabsMenuScroll() {
  if (!shouldScrollTabsMenu()) return;

  scheduleScroll();
  setTimeout(scrollActiveTabsMenus, 100);
  setTimeout(scrollActiveTabsMenus, 500);
}

function shouldScrollTabsMenu() {
  return "matchMedia" in window && window.matchMedia(mobileMediaQuery).matches;
}

function scheduleScroll() {
  if ("requestAnimationFrame" in window) {
    window.requestAnimationFrame(scrollActiveTabsMenus);
  } else {
    scrollActiveTabsMenus();
  }
}

function scrollActiveTabsMenus() {
  document.querySelectorAll(menuSelector).forEach(function(menu) {
    const activeLink = menu.querySelector(activeSelector);

    if (!activeLink || menu.scrollWidth <= menu.clientWidth) return;

    menu.scrollLeft = getCenteredScrollLeft(menu, activeLink);
  });
}

function getCenteredScrollLeft(menu, activeLink) {
  const targetLeft = activeLink.offsetLeft - ((menu.clientWidth - activeLink.offsetWidth) / 2);
  const maxScrollLeft = menu.scrollWidth - menu.clientWidth;

  return Math.max(0, Math.min(targetLeft, maxScrollLeft));
}
